import React, { useEffect, useState, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useOutletContext, useNavigate } from "react-router";
import { emailTriggers } from "../../../utils/mainTabs/admin/emailTriggers";
import { useDispatch } from "react-redux";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import useComponentVisible from "../../../hooks/useComponentVisible";
import { getUserByNameActionHandler } from "../../../store/actions/actionHandlers/eventActionHandler";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Button from "../../../components/Common/Button/Button";
import Input from "../../../components/Common/Input/Input";
import UserRegistration from "../../../components/Common/SvgIcons/AdminIcons/EmailTriggers/UserRegistration";
import DeactivateUser from "../../../components/Common/SvgIcons/AdminIcons/EmailTriggers/DeactivateUser";
import QuotaExceeded from "../../../components/Common/SvgIcons/AdminIcons/EmailTriggers/QuotaExceeded";
import { postSendToQueueActionHandler } from "../../../store/actions/actionHandlers/adminActionHandler/sendToQueueActionHandler";
import classes from "./EmailTriggers.module.scss";
import { FormattedMessage, injectIntl } from "react-intl";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";

export const schema = yup.object().shape({
  users: yup.string().required(<FormattedMessage id="USER_ERR" />),
});

const EmailTriggers = ({ intl }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setAdminHeader, setAdminNavLinks, setAdminTiles, tenantName } =
    useOutletContext();
  const [APIData, setAPIData] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userFilteredResults, setUserFilterResults] = useState([]);
  const [userRef, isUserComponentVisible, setIsUserComponentVisible] =
    useComponentVisible();
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    // shouldFocusError: true,
  });
  const {
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = methods;
  const dropdownlist = watch("users");
  const checkboxCheck = watch("EmailTemplate");
  useEffect(() => {
    setAdminHeader("");
    setAdminTiles("");
    setAdminNavLinks(emailTriggers.navLinks(navigate, tenantName));
  }, [navigate, setAdminHeader, setAdminNavLinks, tenantName]);

  const handleGetUserByName = useCallback(
    (e) => {
      setIsUserComponentVisible(true);
      setValue("EmailTemplate", "")
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        dispatch(getUserByNameActionHandler(e.target.value, setUserList));
        const userfilterData = APIData?.filter(
          (item) =>
            item?.fullName
              ?.toLowerCase()
              .indexOf(e.target.value.toLowerCase()) >= 0
        );
        setUserFilterResults(userfilterData);
      } else {
        setUserFilterResults(APIData);
      }
    },
    [dispatch]
  );
  const userlistOnClick = () => {
    setIsUserComponentVisible(!isUserComponentVisible);
    // dispatch(getUsersRoles(userList[0].ID, setUserRolesList));
  };
  // console.log(userList)
  const onSubmit = (data) => {
    const securityProviderName = localStorage
      .getItem("SecurityProviderName")
      ?.toLowerCase();
    const postData = {
      EmailTemplate: data.EmailTemplate.toString(),
      // IsCustomLogin: securityProviderName === "aad" ? false : true,
      // IsHybrid: false,
      IsCustomLogin: !["aad", "saml2"].includes(securityProviderName),
      IsHybrid: securityProviderName === "saml2",
      IsSAMLLogin: securityProviderName === "saml2",
      UserIds: [userList[0]?.ID],
    };
    dispatch(postSendToQueueActionHandler(postData)).then((response) => {
      if (response.status === 204) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            "Email has been added to queue, shortly user will receive the email."
          )
        );
        reset();
      }
    });
  };

  return (
    <BoxLayout padding={[0, 0, 0, 0]}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.emailTriggers}>
            <h1 className={classes.title}>Select User & Trigger Mail</h1>
            <div className={classes.inputAndUsers}>
              <div className={classes.inputSearch}>
                <Input
                  label={<FormattedMessage id="SELECT_USER" />}
                  placeholder={intl.formatMessage({
                    id: `ANALYTICAL_SEARCH_USER_TEXT`,
                  })}
                  name="users"
                  labelColor="light"
                  required
                  fieldName={"fullNameLoginId"}
                  onChange={handleGetUserByName}
                  search
                  error={errors?.users?.message}
                />
                {isUserComponentVisible ? (
                  <div>
                    {dropdownlist?.length > 0 && (
                      <ul>
                        {userList?.map((item) => {
                          return (
                            <li
                              key={item.ID}
                              onClick={() => {
                                setValue("users", item.fullNameLoginId);
                                userlistOnClick();
                              }}
                            >
                              {item.fullNameLoginId}
                            </li>
                          );
                        })}
                        {userList.length === 0 && (
                          <li style={{ cursor: "auto" }}>No result found.</li>
                        )}
                      </ul>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className={classes.selectRoleUserList}>
                <div className={classes.selectRoleUserList__title}>
                  Email Type
                </div>
                <ul>
                  <li>
                    <span className={classes.userRoleIcon}>
                      <UserRegistration />
                    </span>
                    <Input
                      label={"User Registration"}
                      type="checkbox"
                      name="EmailTemplate"
                      value="User Registration"
                      height={1.5}
                      width="100%"
                      direction={"column"}
                    // required= 'error Message'
                    />
                  </li>
                  <li>
                    <span className={classes.userRoleIcon}>
                      <DeactivateUser />
                    </span>
                    <Input
                      label={"Deactivate User"}
                      type="checkbox"
                      name="EmailTemplate"
                      value="Deactivate User"
                      height={1.5}
                      width="100%"
                      direction={"column"}
                      disabled
                    // error={errors?.EmailTemplate?.message}
                    />
                  </li>
                  <li>
                    <span className={classes.userRoleIcon}>
                      <QuotaExceeded />
                    </span>
                    <Input
                      label={"Quota Exceeded"}
                      type="checkbox"
                      name="EmailTemplate"
                      value="Quota Exceeded"
                      height={1.5}
                      width="100%"
                      direction={"column"}
                      disabled
                    // error={errors?.EmailTemplate?.message}
                    />
                  </li>
                </ul>
                {/* <div>{errors?.EmailTemplate?.message}</div> */}
              </div>
              <div className={classes.emailTriggersBtn}>
                <Button
                  small
                  dark
                  label={<FormattedMessage id="NOTIFICATION_TYPE" />}
                  width={"18.6"}
                  height={"3.6"}
                  type={"submit"}
                  disabled={!(checkboxCheck?.length > 0)}
                />
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </BoxLayout>
  );
};

export default injectIntl(EmailTriggers);
